import styled from 'styled-components'

const Text = styled.p`
  font-size: 0.9rem;
  line-height: 1;
  margin: 0.25rem;
`

export default Text



// WEBPACK FOOTER //
// ./src/components/styled/Text.js